/**
 * Session expiry event bus.
 * Tiny module — no dependencies. Emit when a refresh definitely fails for an
 * authenticated request; listen in SessionExpiredModal.
 */

export const SESSION_EXPIRED_EVENT = 'ignis:session-expired'

export function emitSessionExpired(): void {
  window.dispatchEvent(new CustomEvent(SESSION_EXPIRED_EVENT))
}
